import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import "./login.css";

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");
  const turnstileSiteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;

  useEffect(() => {
    const scriptId = "cf-turnstile-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    window.onTurnstileSuccess = (token) => setTurnstileToken(token);
    window.onTurnstileExpired = () => setTurnstileToken("");

    return () => {
      delete window.onTurnstileSuccess;
      delete window.onTurnstileExpired;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!turnstileToken) {
        return;
      }
      await login(username, password, turnstileToken);
    } catch (err) {
      // Silent fail
    }
  };

  return (
    <div className="login-container">
      <form className="login-box" onSubmit={handleSubmit}>
        <h2>Login</h2>
        <input
          type="text"
          placeholder="Benutzername"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <div className="turnstile-wrapper">
          <div
            className="cf-turnstile"
            data-sitekey={turnstileSiteKey || ""}
            data-callback="onTurnstileSuccess"
            data-expired-callback="onTurnstileExpired"
          />
        </div>
        {!turnstileSiteKey && (
          <p className="login-hint">Captcha ist nicht konfiguriert.</p>
        )}
        <button type="submit" disabled={!turnstileToken || !turnstileSiteKey}>
          Einloggen
        </button>
      </form>
    </div>
  );
}
